import { MenuItem } from '@chakra-ui/react'
import { FC } from 'react'
import { GrDocumentCsv } from 'react-icons/gr'

import useStoreBudget from '@hook/budget/use-store'
import useTools from '@hook/shared/use-tools'

import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'
const ActionExcelStoreConsolidatedExport: FC<ILayoutToolsExportAction> = () => {
  const { isDisabled } = useTools()
  const { exportDataConsolidated } = useStoreBudget()
  return (
    <MenuItem
      p="2px 12px"
      fontSize="sm"
      bgColor="white"
      _hover={{ bg: 'gray.400' }}
      isDisabled={isDisabled}
      onClick={exportDataConsolidated}
      icon={<GrDocumentCsv />}
    >
      Exportar Consolidado para CSV
    </MenuItem>
  )
}

export default ActionExcelStoreConsolidatedExport
